import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { GetContentCollectionsQuery, GetContentCollectionsQueryVariables } from '@/types/codegen-federation'
import { GetWatchCollectionContentQuery, GetWatchCollectionContentQueryVariables } from '@/types/codegen-federation'
import { logger } from '@/utils/logging'
import { GET_CONTENT_COLLECTIONS, GET_WATCH_COLLECTION_CONTENT } from './queries'
import { ContentCollection, ContentCollections, WatchCollectionContent, WatchCollectionContents } from './types'

export const getContentCollections = async (
  ids: string[],
  client: ApolloClient<NormalizedCacheObject>,
): Promise<ContentCollections> => {
  try {
    const { data } = await client.query<GetContentCollectionsQuery, GetContentCollectionsQueryVariables>({
      query: GET_CONTENT_COLLECTIONS,
      variables: { ids, first: 50, after: null },
      errorPolicy: 'all',
    })

    if (!data?.contentCollections) return []
    return data.contentCollections.filter(isValidContentCollection)
  } catch (error) {
    logger().error('Error fetching content collections', { ids }, error)
    return []
  }
}

export const getWatchCollectionContent = async (
  ids: string[],
  client: ApolloClient<NormalizedCacheObject>,
): Promise<WatchCollectionContents> => {
  try {
    const { data } = await client.query<GetWatchCollectionContentQuery, GetWatchCollectionContentQueryVariables>({
      query: GET_WATCH_COLLECTION_CONTENT,
      variables: { ids, first: 50, after: null },
      errorPolicy: 'all',
    })

    if (!data?.contentCollections) return []
    return data.contentCollections.filter(isValidWatchCollection)
  } catch (error) {
    logger().error('Error fetching watch collection content', { ids }, error)
    return []
  }
}

const isValidWatchCollection = (collection: WatchCollectionContent | null | undefined): boolean => {
  return !!collection?.connection?.edges?.length
}

export const isValidContentCollection = (collection: ContentCollection | null | undefined): boolean => {
  return !!(collection?.title && collection?.connection?.edges?.length)
}
